module.exports = __webpack_public_path__ + "static/media/default-avatar.e4d9a43c.svg";